import alert_mixin from "@/utils/mixins/alert_mixin";
import ApplicationDetailsReview from "@/components/config_components/ApplicationDetailsReview/ApplicationDetailsReview.vue";
import HistoricalVerificationChecksView from "@/components/config_components/HistoricalVerificationChecksView/HistoricalVerificationChecksView.vue";
import ManualVerificationHistoryView from "@/components/config_components/ManualVerificationHistoryView/ManualVerificationHistoryView.vue";
import ConfigureSigners from "@/views/onboarding_system_views/Gates/EsigningManagement/ConfigureSigners/ConfigureSigners.vue";
import DocumentPreview from "@/views/onboarding_system_views/Gates/EsigningManagement/DocumentPreview/DocumentPreview.vue";
import DocumentSubmission from "@/views/onboarding_system_views/Gates/EsigningManagement/DocumentSubmission/DocumentSubmission.vue";
import {
    DEFAULT_SIGNING_FILTER,
    esigning_setup_computed
} from "./esigning_setup_computed_helpers";
import { esigning_setup_methods } from "./esigning_setup_methods_helpers";

function should_open_signing_request_from_route(route = {}, has_signing_context = false, can_manage_signing_requests = false) {
    return String(route?.query?.startNewSigning || "") === "1" && has_signing_context && can_manage_signing_requests;
}

export default {
    name: "EsigningSetup",
    mixins: [alert_mixin],
    components: {
        ApplicationDetailsReview,
        HistoricalVerificationChecksView,
        ManualVerificationHistoryView,
        ConfigureSigners,
        DocumentPreview,
        DocumentSubmission
    },
    data: () => ({
        all_cases: [],
        gate_cases: [],
        selected_case: null,
        selected_case_summary: null,
        loading_cases: false,
        loading_selected_case: false,
        is_loading_summary_detail: false,
        opening_case_id: null,
        initialized_gate_cases: false,
        detail_tab_overflow: {
            left: false,
            right: false
        },
        cases_error: "",
        case_table_search: "",
        active_detail_tab: "signing",
        active_summary_detail_tab: "summary",
        is_summary_detail_fullscreen: false,
        summary_rows: [],
        summary_stage_timeline: [],
        summary_case_form_sections: [],
        configured_gate_ids: [],
        workflow_transition_history: [],
        summary_detail_tabs: [
            { id: "summary", label: "Summary", icon: "bi-grid" },
            { id: "application", label: "Applicant information", icon: "bi-list-check" }
        ],
        historical_gate_checks_by_gate: {},
        historical_risk_questions: [],
        historical_risk_weights: [],
        historical_risk_submitted: null,
        historical_risk_assessment_name: "",
        expanded_historical_verification_keys: [],
        show_new_signing_request: false,
        current_request_step: 1,
        active_signing_filter: DEFAULT_SIGNING_FILTER,
        table_search: "",
        selected_template: null,
        template_bindings: [],
        template_bindings_loading: false,
        template_bindings_error: "",
        sent_contracts: [],
        sent_contracts_loading: false,
        sent_contracts_error: "",
        entity_config_id: null,
        signers_step_busy: false,
        signer_configuration_summary: null,
        populated_preview_url: "",
        populated_preview_external_url: "",
        populated_preview_form_src: "",
        populated_preview_token: "",
        populated_preview_loading: false,
        populated_preview_error: "",
        sending_contract: false
    }),
    computed: esigning_setup_computed,
    mounted() {
        window.addEventListener("resize", this.update_detail_tab_overflow);
        this.initialize_esigning_view(this.$route);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.update_detail_tab_overflow);
    },
    watch: {
        $route: {
            handler(next_route) {
                this.initialize_esigning_view(next_route);
            },
            deep: true
        }
    },
    methods: {
        ...esigning_setup_methods,
        current_summary_action_tab() {
            return this.summary_detail_tabs[0] || null;
        },
        summary_reference_tab() {
            return this.summary_detail_tabs.find((tab) => String(tab?.id || "").trim().toLowerCase() === "application")
                || this.summary_detail_tabs[1]
                || null;
        },
        summary_current_action_copy() {
            return "Open the e-signing workspace to configure signers, prepare the document, and send it out for signature.";
        },
        current_detail_action_copy() {
            if (this.show_new_signing_request) {
                if (this.current_request_step === 1) {
                    return "Choose the document template and recipient details before moving to signer setup.";
                }

                if (this.current_request_step === 2) {
                    return "Set up who will sign, define the signing order, and save the signer configuration.";
                }

                return "Review the populated document and signer setup, then send it out for signing.";
            }

            return "Set up the people who will sign, manage signing requests, and send documents out for signature.";
        },
        current_detail_action_heading() {
            if (this.show_new_signing_request) {
                if (this.current_request_step === 1) {
                    return "Select document and recipient";
                }

                if (this.current_request_step === 2) {
                    return "Configure signers and order";
                }

                return "Review and send signing request";
            }

            return "Manage e-signing setup";
        },
        summary_reference_value() {
            const application_id = String(this.selected_case_summary?.application_id || this.selected_case_summary?.id || "").trim();
            return application_id ? `#${application_id}` : "Open application details";
        },
        sync_signing_request_view_with_route(route = this.$route) {
            if (should_open_signing_request_from_route(route, this.has_signing_context, this.can_manage_signing_requests)) {
                this.open_new_signing_request();
                return;
            }

            if (this.show_new_signing_request) {
                this.close_new_signing_request();
            }
        }
    }
};
